module.exports = __webpack_public_path__ + "img/network-4.183c6871.png";